import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { selectEntitiesByFilters } from "../../../../shared/store/views/entityView";
import { useEffect, useMemo } from "react";
import { addOrUpdateUserBoardAccess } from "../../../../shared/store/redux/entities-action";
import { objectToNullNmmDomain } from "../../../../student/utils/utils";
import { galleryFilters, makpezaFiltersByDomain, teachingAssistantBotByDomain, teacherGalleryFiltersByDomain } from "../../../../shared/utils/entitiesFiltersUtils";
import boardType from "../../../../shared/enums/boardType";
import TeachingAssistantWidget from "./teachingAssistantWidget/TeachingAssistantWidget";
import UseFullToolByNmm from "./useFullToolByNmm/UseFullToolByNmm";
import RegularAppletsWidget from "../../../features/appletsWidget/regularAppletsWidget/RegularAppletsWidget";
import MobileAppletsWidget from "../../../features/appletsWidget/mobileAppletsWidget/MobileAppletsWidget";
import MiniWidget from "../../../../shared/components/features/widget/miniWidget/MiniWidget";
import MyLearningDomainHeader from "../../../../shared/components/pages/myLearningPage/myLearningDomainPage/myLearningDomainHeader/MyLearningDomainHeader";
import CoursesNmmWidget from "./coursesDomainWidget/CoursesNmmWidget";
import MessagesNmmWidget from "./messagesDomainWidget/MessagesNmmWidget";
import CourseGallery from "../../../../shared/components/features/courseGallery/CourseGallery";
import MobileBanner from "../../../../shared/components/ui/mobileBanner/MobileBanner";
import Page from "../../../../shared/components/ui/page/Page";
import pathRouts from "../../../../shared/enums/pathRoute";
import useMyLearningNmm from "../../../../shared/components/pages/myLearningPage/useMyLearningNmm";
import { usePermission } from "../../../../shared/hooks/usePermission";
import { getTab } from "../../../../shared/utils/tabsUtils";
import { deviceTypes } from "../../../../shared/enums/deviceTypes";
import classes from './MyLearningNmmPage.module.css'

const MyLearningNmmPage = () => {

    const navigate = useNavigate();
    const { domainName, studyGroupId } = useParams();
    const { texts, lang } = useSelector(state => state.translate);
    const { general } = useSelector(state => state.uiData);
    const deviceType = useSelector(state => state.responsive.deviceType);
    const domains = useSelector(state => state.uiData.domains);
    const hasPermission = usePermission();
    const canSeeBots = hasPermission(getTab("bots")?.visibleTo);
    const domain = useMemo(() => domains?.find(d => d.name === domainName) || objectToNullNmmDomain(domainName), [domains, domainName]);
    const botFilter = useMemo(() => teachingAssistantBotByDomain(domainName), [domainName]);
    const teachingAssistantBot = useSelector(state => selectEntitiesByFilters(state, botFilter))?.[0];
    const domainImage = domain?.cardDomainImg || domain?.matriculation?.cardDomainImg;
    const makpezaFilter = useMemo(() => makpezaFiltersByDomain(domainName, lang), [domainName, lang]);
    const galleryFilter = useMemo(() => galleryFilters(domainName, lang), [domainName, lang]);
    const teacherGalleryDomainFilter = useMemo(() => teacherGalleryFiltersByDomain(domainName, lang), [domainName, lang]);
    const galleryCourses = useSelector(state => selectEntitiesByFilters(state, galleryFilter));
    const makpezaCourses = useSelector(state => selectEntitiesByFilters(state, makpezaFilter));
    const dispatch = useDispatch();

    useEffect(() => {
        if (studyGroupId) {
            dispatch(addOrUpdateUserBoardAccess(`${boardType.messagesByNmm}_${studyGroupId}`));
        }
    }, [studyGroupId, dispatch]);
    const teacherGalleryDomainCourses = useSelector(state => selectEntitiesByFilters(state, teacherGalleryDomainFilter));

    return (
        <Page
            image={domainImage}
            onBack={() => navigate(`/${pathRouts.MYLEARNING}`)}
            headerEndContent={<MyLearningDomainHeader domain={domain} nmmId={studyGroupId} />}
            className={classes.MyLearningNmmPage}
        >
            <div className={classes.MyLearningDomainPage}>
                <div className={classes.Content}>
                    <div className={classes.TopPart}>
                        <div className={classes.TopRightPart}>
                            <MessagesNmmWidget studyGroupIds={[studyGroupId]} />
                            <CoursesNmmWidget studyGroupId={studyGroupId} />
                            <div className={classes.AppletsWrap}>
                                {deviceType === deviceTypes.mobile ?
                                    <MobileAppletsWidget />
                                    :
                                    <RegularAppletsWidget studyGroupId={studyGroupId} />
                                }
                            </div>
                        </div>
                        <div className={classes.TopLeftPart}>
                            {/* <BagroupAndMakpezeBanners domainName={domainName} /> */}
                            {canSeeBots && teachingAssistantBot && <TeachingAssistantWidget bot={teachingAssistantBot} />}
                            <UseFullToolByNmm studyGroupId={studyGroupId} />
                            <div className={classes.MinisWidgwts}>
                                <MiniWidget text={texts.assmentsClassromToCheck} color={" #FDDB71"} classNameText={classes.textMiniWidget} className={classes.ClassroomWidget} link={general.classwoomCheckLink} />
                                {/* <HamafmarTableMiniWidget /> */}
                            </div>
                        </div>
                    </div>

                    <div className={classes.BottomPart}>
                        {teacherGalleryDomainCourses?.length > 0 &&
                        <div className={classes.Gallery}>
                            <CourseGallery
                                courses={teacherGalleryDomainCourses}
                                title={texts.musicalPath}
                            />
                        </div>
                    }
                    {makpezaCourses?.length > 0 &&
                            <div className={classes.Gallery}>
                                <CourseGallery
                                    courses={makpezaCourses}
                                    title={texts.makpeza}
                                    color="#E2EDF5"
                                    promoImg={general?.makpeza?.promoImg?.[lang]}
                                />
                            </div>
                        }
                        {galleryCourses?.length > 0 &&
                            <div className={classes.Gallery}>
                                <CourseGallery
                                    courses={galleryCourses}
                                    title={texts.coursesByStudyPlan}
                                />
                            </div>
                        }
                        <MobileBanner text={texts.myLearningNmmMobileBanner} className={classes.MobileBanner} />
                    </div>
                </div>
            </div>
        </Page>
    );
}
export default MyLearningNmmPage;
